<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2020-09-15',
        items: [

          // [NOTE] FR
          // ================================================================================

          item({
            collection  : 'PritickePack07',
            id          : 'AM-530',
            rare        : 'FR',
            name        : 'プリ☆ファンおうさまダークトップス',
            imgUrl      : '/images/items/AM-530.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 1100,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-531',
            rare        : 'FR',
            name        : 'プリ☆ファンおうさまダークパンツ',
            imgUrl      : '/images/items/AM-531.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'PM',
            type        : 'PR',
            point       : 1050,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-532',
            rare        : 'FR',
            name        : 'プリ☆ファンおうさまダークシューズ',
            imgUrl      : '/images/items/AM-532.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-533',
            rare        : 'FR',
            name        : 'プリ☆ファンおうさまダークヘアアクセ',
            imgUrl      : '/images/items/AM-533.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'PritickePack07',
            id          : 'AM-482',
            rare        : 'PR',
            name        : 'やみよのあくまトップス',
            imgUrl      : '/images/items/AM-482.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-483',
            rare        : 'PR',
            name        : 'やみよのあくまスカート',
            imgUrl      : '/images/items/AM-483.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-484',
            rare        : 'PR',
            name        : 'やみよのあくまシューズ',
            imgUrl      : '/images/items/AM-484.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-485',
            rare        : 'PR',
            name        : 'やみよのあくまヘアアクセ',
            imgUrl      : '/images/items/AM-485.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PritickePack07',
            id          : 'AM-486',
            rare        : 'PR',
            name        : 'ゆめサイリウムゆいアナザーワンピ',
            imgUrl      : '/images/items/AM-486.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : 'PP_FT',
            type        : 'LO',
            point       : 1610,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-487',
            rare        : 'PR',
            name        : 'ゆめサイリウムゆいアナザーシューズ',
            imgUrl      : '/images/items/AM-487.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'PP_FT',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-488',
            rare        : 'PR',
            name        : 'ゆめサイリウムゆいアナザーヘアアクセ',
            imgUrl      : '/images/items/AM-488.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'PP_FT',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            rare        : 'PR',
          }),


          item({
            collection  : 'PritickePack07',
            id          : 'AM-489',
            rare        : 'PR',
            name        : 'よるのアナザーワンピ',
            imgUrl      : '/images/items/AM-489.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'PP_CG',
            type        : 'PR',
            point       : 1610,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-490',
            rare        : 'PR',
            name        : 'よるのアナザーシューズ',
            imgUrl      : '/images/items/AM-490.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'PP_CG',
            type        : 'PR',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-491',
            rare        : 'PR',
            name        : 'よるのアナザーヘアアクセ',
            imgUrl      : '/images/items/AM-491.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'PP_CG',
            type        : 'PR',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            rare        : 'PR',
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'PritickePack07',
            id          : 'AM-492',
            rare        : 'SR',
            name        : 'はなのプリパリブラックトップス',
            imgUrl      : '/images/items/AM-492.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'PP_BP',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-493',
            rare        : 'SR',
            name        : 'はなのプリパリブラックパンツ',
            imgUrl      : '/images/items/AM-493.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'PP_BP',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-494',
            rare        : 'SR',
            name        : 'はなのプリパリブラックシューズ',
            imgUrl      : '/images/items/AM-494.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'PP_BP',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-495',
            rare        : 'SR',
            name        : 'はなのプリパリブラックヘアアクセ',
            imgUrl      : '/images/items/AM-495.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'PP_BP',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PritickePack07',
            id          : 'AM-496',
            rare        : 'SR',
            name        : 'ねこうらないしピンクワンピ',
            imgUrl      : '/images/items/AM-496.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-497',
            rare        : 'SR',
            name        : 'ねこうらないしピンクシューズ',
            imgUrl      : '/images/items/AM-497.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-498',
            rare        : 'SR',
            name        : 'ねこうらないしピンクヘアアクセ',
            imgUrl      : '/images/items/AM-498.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            rare        : 'SR',
          }),


          item({
            collection  : 'PritickePack07',
            id          : 'AM-499',
            rare        : 'SR',
            name        : 'トライアングルミルキーポップワンピ',
            imgUrl      : '/images/items/AM-499.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'PP_RJ',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-500',
            rare        : 'SR',
            name        : 'トライアングルミルキーポップシューズ',
            imgUrl      : '/images/items/AM-500.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'PP_RJ',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-501',
            rare        : 'SR',
            name        : 'トライアングルミルキーポップヘアアクセ',
            imgUrl      : '/images/items/AM-501.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'PP_RJ',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            rare        : 'SR',
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'PritickePack07',
            id          : 'AM-502',
            rare        : 'R',
            name        : 'ゆうびんやさんかんぺきワンピ',
            imgUrl      : '/images/items/AM-502.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 6 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-503',
            rare        : 'R',
            name        : 'ゆうびんやさんかんぺきシューズ',
            imgUrl      : '/images/items/AM-503.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 7 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-504',
            rare        : 'R',
            name        : 'ゆうびんやさんかんぺきヘアアクセ',
            imgUrl      : '/images/items/AM-504.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            rare        : 'R',
          }),


          item({
            collection  : 'PritickePack07',
            id          : 'AM-505',
            rare        : 'R',
            name        : 'にゃんにゃんにゃ～すオレンジトップス',
            imgUrl      : '/images/items/AM-505.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 6 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-506',
            rare        : 'R',
            name        : 'にゃんにゃんにゃ～すオレンジスカート',
            imgUrl      : '/images/items/AM-506.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-507',
            rare        : 'R',
            name        : 'にゃんにゃんにゃ～すオレンジブーツ',
            imgUrl      : '/images/items/AM-507.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-508',
            rare        : 'R',
            name        : 'にゃんにゃんにゃ～すオレンジヘアアクセ',
            imgUrl      : '/images/items/AM-508.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PritickePack07',
            id          : 'AM-509',
            rare        : 'R',
            name        : 'イースターブルーうさぎトップス',
            imgUrl      : '/images/items/AM-509.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-510',
            rare        : 'R',
            name        : 'イースターブルーうさぎスカート',
            imgUrl      : '/images/items/AM-510.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-511',
            rare        : 'R',
            name        : 'イースターブルーうさぎシューズ',
            imgUrl      : '/images/items/AM-511.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-512',
            rare        : 'R',
            name        : 'イースターブルーうさぎヘアアクセ',
            imgUrl      : '/images/items/AM-512.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PritickePack07',
            id          : 'AM-513',
            rare        : 'R',
            name        : 'ヴィンテージチェックブルーワンピ',
            imgUrl      : '/images/items/AM-513.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-514',
            rare        : 'R',
            name        : 'ヴィンテージチェックブルーシューズ',
            imgUrl      : '/images/items/AM-514.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-515',
            rare        : 'R',
            name        : 'ヴィンテージチェックブルーヘアアクセ',
            imgUrl      : '/images/items/AM-515.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 6 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            rare        : 'R',
          }),


          item({
            collection  : 'PritickePack07',
            id          : 'AM-516',
            rare        : 'R',
            name        : 'ローズ＆レースレッドワンピ',
            imgUrl      : '/images/items/AM-516.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-517',
            rare        : 'R',
            name        : 'ローズ＆レースレッドシューズ',
            imgUrl      : '/images/items/AM-517.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 8 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-518',
            rare        : 'R',
            name        : 'ローズ＆レースレッドヘアアクセ',
            imgUrl      : '/images/items/AM-518.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            rare        : 'R',
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : 'PritickePack07',
            id          : 'AM-519',
            rare        : 'N',
            name        : 'トランプディーラーブルートップス',
            imgUrl      : '/images/items/AM-519.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SA',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-520',
            rare        : 'N',
            name        : 'トランプディーラーブルーボトムス',
            imgUrl      : '/images/items/AM-520.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SA',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 7 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-521',
            rare        : 'N',
            name        : 'トランプディーラーブルーシューズ',
            imgUrl      : '/images/items/AM-521.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SA',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-522',
            rare        : 'N',
            name        : 'トランプディーラーブルーヘアアクセ',
            imgUrl      : '/images/items/AM-522.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SA',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PritickePack07',
            id          : 'AM-523',
            rare        : 'N',
            name        : 'ニュースペーパーダンスブルージャケット',
            imgUrl      : '/images/items/AM-523.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-524',
            rare        : 'N',
            name        : 'ニュースペーパーダンスブルーパンツ',
            imgUrl      : '/images/items/AM-524.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-525',
            rare        : 'N',
            name        : 'ニュースペーパーダンスブルーシューズ',
            imgUrl      : '/images/items/AM-525.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-526',
            rare        : 'N',
            name        : 'ニュースペーパーダンスブルーヘアアクセ',
            imgUrl      : '/images/items/AM-526.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 7 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PritickePack07',
            id          : 'AM-527',
            rare        : 'N',
            name        : 'パステルチューリップピンクワンピ',
            imgUrl      : '/images/items/AM-527.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-528',
            rare        : 'N',
            name        : 'パステルチューリップピンクシューズ',
            imgUrl      : '/images/items/AM-528.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            id          : 'AM-529',
            rare        : 'N',
            name        : 'パステルチューリップピンクヘアアクセ',
            imgUrl      : '/images/items/AM-529.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PritickePack07',
            rare        : 'N',
          }),
        ]
      }
    },

    computed: {
      itemsFR () {
        return _.where(this.items, {  rare: 'FR' })
      },

      itemsPR () {
        return _.where(this.items, {  rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.items, {  rare: 'SR' })
      },

      itemsR () {
        return _.where(this.items, {  rare: 'R' })
      },

      itemsN () {
        return _.where(this.items, {  rare: 'N' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="👑 FR 👑" color="#ff5d91" :items="itemsFR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
    </template>

    <template #col2>
    </template>

    <template #col3>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
    </template>

    <template #col4>
      <Status :date="date" :items="items" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    top: $size-unit * 15;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 10;
  //   }
  // }
</style>
